// extracted by mini-css-extract-plugin
export default {"ScrollTable":"scrollTable_ScrollTable__bVZ5a"};